/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Group} from "../models/group";
import {UserGroupService} from "../services/user-group.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class RolesResolver implements Resolve<Group[]> {

  constructor(
    private mRoleService: UserGroupService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Group[]> {
    try {
      return await this.mRoleService.getAllUserGroups();
    } catch (error) {
      console.error("Problem resolving Roles.... Error: " + error, error);
    }
  }

}
